import Base from './base.js';

export default class ArticleType extends Base{
    static relations = {
        oneToMany: ['articleGroup']
    }
}